// src/pages/buyer/CheckoutSuccess.jsx
import { useSearchParams, Link } from 'react-router-dom'
import { CheckCircle } from 'lucide-react'
import { Button } from '../../components/common/ui'

export default function CheckoutSuccess() {
  const [sp] = useSearchParams()
  const orderId = sp.get('order_id')

  return (
    <div className="max-w-md mx-auto py-16 text-center px-4">
      <div className="w-20 h-20 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-6">
        <CheckCircle size={40} className="text-green-500" />
      </div>
      <h1 className="text-2xl font-display font-bold text-gray-900 mb-2">Order Placed! 🎉</h1>
      <p className="text-gray-600 text-sm mb-8">Thank you for your purchase. You'll receive a confirmation email shortly.</p>
      <div className="flex gap-3 justify-center flex-wrap">
        {orderId && (
          <Link to={`/buyer/orders/${orderId}`}><Button>View Order</Button></Link>
        )}
        <Link to="/buyer/orders"><Button variant="secondary">All Orders</Button></Link>
        <Link to="/fabrics"><Button variant="ghost">Continue Shopping</Button></Link>
      </div>
    </div>
  )
}
